module.exports = __webpack_public_path__ + "static/media/ic_launcher.359c7209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/ic_launcher.png
// module id = 3829
// module chunks = 1